module.exports = __webpack_public_path__ + "static/anti-racist-teaching-39a026fc36aa9d3abc403c172654e463.jpg";